var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import LocationService from "../../../Services/Location.service";
import { LocationStatusId } from "../../../Domain/LocationStatus/LocationStatus.service";
const makeSearchArgs = {
    loadOptions: (search, options) => __awaiter(void 0, void 0, void 0, function* () {
        if (options.forceEmptyReturn) {
            return new Promise((resolve) => {
                resolve([]);
            });
        }
        const { data } = yield LocationService.search(Object.assign({ locationStatusesInclude: [LocationStatusId.Active], query: search }, options));
        return data;
    }),
    label: "name",
    value: "id",
};
export const LocationSearch = makeSearch(makeSearchArgs);
export const LocationMultiSearch = makeMultiSearch(makeSearchArgs);
